import { z } from 'zod';
import { isDefined, isTruthy } from '../typeUtils/index.js';
/** A string field where the empty string is treated as absent. */
export const OptionalTruthyStringSchema = z
    .string()
    .transform((value) => (isTruthy(value) ? value : undefined))
    .optional();
/** A string field where a blank (whitespace-only) value is treated as absent. */
export const OptionalBlankableStringSchema = z.preprocess((value) => (typeof value === 'string' && !isTruthy(value.trim()) ? undefined : value), z.string().optional());
/**
 * A numeric field arriving as a string — form inputs and template expressions both produce
 * strings. Blank input becomes `undefined`; anything else must parse as a number before
 * `numberValidation` sees it.
 */
export const StringAsNumberSchema = (numberValidation = z.number().optional()) => z.coerce
    .string()
    .optional()
    .transform((value) => (value === '' ? undefined : value))
    .refine((value) => !isDefined(value) || !Number.isNaN(Number(value)), {
    message: 'Invalid number',
})
    .transform((value) => (isDefined(value) ? Number(value) : undefined))
    // Presented as a ZodOptional so the inferred object key stays optional.
    .pipe(numberValidation);
/** Route params for a resource the path addresses by a bare `id`. */
export const UuidIdParamsSchema = z.object({ id: z.uuid() }).strict();
//# sourceMappingURL=fieldSchemas.js.map